import { render } from "./AdminSettings.vue?vue&type=template&id=4983f305&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=js"
export * from "./AdminSettings.vue?vue&type=script&lang=js"

import "./AdminSettings.vue?vue&type=style&index=0&id=4983f305&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4983f305"]])

export default __exports__